import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const VideoPlay = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/video-play">
        <g id="video-play">
          <path
            id="Vector"
            d="M9.9987 15.1667H5.9987C2.3787 15.1667 0.832031 13.62 0.832031 10V6.00004C0.832031 2.38004 2.3787 0.833374 5.9987 0.833374H9.9987C13.6187 0.833374 15.1654 2.38004 15.1654 6.00004V10C15.1654 13.62 13.6187 15.1667 9.9987 15.1667ZM5.9987 1.83337C2.92536 1.83337 1.83203 2.92671 1.83203 6.00004V10C1.83203 13.0734 2.92536 14.1667 5.9987 14.1667H9.9987C13.072 14.1667 14.1654 13.0734 14.1654 10V6.00004C14.1654 2.92671 13.072 1.83337 9.9987 1.83337H5.9987Z"
          />
          <path
            id="Vector_2"
            d="M14.3197 5.23999H1.67969C1.40635 5.23999 1.17969 5.01332 1.17969 4.73999C1.17969 4.46666 1.39969 4.23999 1.67969 4.23999H14.3197C14.593 4.23999 14.8197 4.46666 14.8197 4.73999C14.8197 5.01332 14.5997 5.23999 14.3197 5.23999Z"
          />
          <path
            id="Vector_3"
            d="M5.67969 5.14662C5.40635 5.14662 5.17969 4.91995 5.17969 4.64662V1.40662C5.17969 1.13328 5.40635 0.906616 5.67969 0.906616C5.95302 0.906616 6.17969 1.13328 6.17969 1.40662V4.64662C6.17969 4.91995 5.95302 5.14662 5.67969 5.14662Z"
          />
          <path
            id="Vector_4"
            d="M10.3203 4.84662C10.047 4.84662 9.82031 4.61995 9.82031 4.34662V1.40662C9.82031 1.13328 10.047 0.906616 10.3203 0.906616C10.5936 0.906616 10.8203 1.13328 10.8203 1.40662V4.34662C10.8203 4.62662 10.6003 4.84662 10.3203 4.84662Z"
          />
          <path
            id="Vector_5"
            d="M7.39333 12.08C7.15333 12.08 6.92667 12.02 6.72 11.9066C6.26667 11.64 6 11.1066 6 10.4333V8.8333C6 8.15996 6.26667 7.61996 6.72667 7.3533C7.18667 7.08663 7.78667 7.12663 8.36667 7.46663L9.75333 8.26663C10.3333 8.59996 10.6733 9.09996 10.6733 9.6333C10.6733 10.1666 10.3333 10.6666 9.74667 11L8.36 11.8C8.04 11.9866 7.70667 12.08 7.39333 12.08ZM7.4 8.17996C7.33333 8.17996 7.27333 8.1933 7.22667 8.21996C7.08667 8.29996 7 8.52663 7 8.8333V10.4333C7 10.7333 7.08667 10.96 7.22667 11.0466C7.36667 11.1266 7.60667 11.0866 7.86667 10.9333L9.25333 10.1333C9.51333 9.97996 9.67333 9.7933 9.67333 9.6333C9.67333 9.4733 9.52 9.28663 9.25333 9.1333L7.86667 8.3333C7.69333 8.2333 7.52667 8.17996 7.4 8.17996Z"
          />
        </g>
      </g>
    </svg>
  );
};

VideoPlay.displayName = 'VideoPlay';
